export const USER_RIGHTS_CONSTANTS = {
  GET_USER_RIGHTS_REQUEST: 'GET_USER_RIGHTS_REQUEST',
  GET_USER_RIGHTS_SUCCESS: 'GET_USER_RIGHTS_SUCCESS',
  GET_USER_RIGHTS_FAILURE: 'GET_USER_RIGHTS_FAILURE',
}
